import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { Dispatch, SetStateAction } from "react";
import UnForm from "../../../../Components/Form";
import { ETAPA_ENTREGA_CHAVES } from "../../../../Constants/EntregaChaves";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import { useHistoricoContext } from "../../../../Context/Historico";
import { CadastrarHistoricoCasoVistoriaController } from "../../../../Controllers/VistoriaEntregaChaves/AcoesVistoria/AcoesVistoriaController";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";

interface IBotaoVistoriaNaoRealizadaProps {
    setShow: Dispatch<SetStateAction<boolean>>;
}

export default function VistoriaNaoRealizada(
    props: IBotaoVistoriaNaoRealizadaProps
) {
    const { updateAtendimento, ID_CASO } = useAtendimentoPage();

    const { ReloadHistorico } = useHistoricoContext();
    const {
        execute: cadastrarHistoricoCasoVistoria,
        loading: cadastrarHistoricoCasoVistoriaLoading,
    } = useAsyncCallback(CadastrarHistoricoCasoVistoriaController);

    function handleCadastrarHistoricoCasoVistoria(formData: {
        dsHistorico: string;
    }) {
        cadastrarHistoricoCasoVistoria({
            DS_HISTORICO: formData.dsHistorico,
            CD_ETAPA:
                ETAPA_ENTREGA_CHAVES.AGENDAR_VISTORIA_NAO_REALIZADA.CD_ETAPA,
            ID_CASO: ID_CASO,
        }).then(() => {
            updateAtendimento();
            ReloadHistorico();
            props.setShow(false);
        });
    }

    return (
        <UnForm handleSubmit={handleCadastrarHistoricoCasoVistoria}>
            <UnForm.Textarea
                label="Favor indicar no campo descritivo abaixo, a data que poderá ser reagendada a vistoria."
                name="dsHistorico"
                registerOptions={{ required: "Deixe a informação necessária." }}
                placeholder="Digite Algo..."
            />

            <UnForm.SubmitButton
                color="success"
                wrapperClassName="w-100 mt-8"
                className="w-100"
                icon={faPaperPlane}
                loading={cadastrarHistoricoCasoVistoriaLoading}
                disabled={cadastrarHistoricoCasoVistoriaLoading}
                loadingSize={"sm"}
            >
                Vistoria Não Realizada
            </UnForm.SubmitButton>
        </UnForm>
    );
}
